<span>{{meetingHandler.getParticipantByUsername(username).name}}</span>
<span><button (click)="remove()" class="btn btn-outline-danger btn-sm"><i class="fas fa-user-times"></i></button></span>